import { adminAxiosInstance } from "../../common/axiosInstance"

export function listInstitutionConfig() {
  return adminAxiosInstance.get("/instConfig/listInstConfig");
}

export function updateInstitutionConfig(application, body) {
  return adminAxiosInstance.put(`/instConfig/update/${application}`, body);
}
